import * as yup from 'yup';


export const EditPersonalInformationValidationSchema = yup.object().shape({
    firstName: yup.string().required('First name is required').max(100, 'First name must be less than 100 characters'),
    lastName: yup.string().required('Surname is required').max(100, 'Surname must be less than 100 characters'),
    idNumber: yup.string().when('employeeCode', {
        is: (EmployeeCode: string) => !EmployeeCode || EmployeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }).max(128, 'ID number must be less than 128 characters'),
    employeeCode: yup.string().when('idNumber', {
        is: (idNumber: string) => !idNumber || idNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required").nullable(),
        otherwise: yup.string().nullable()
    }).max(50, 'Employee code must be less than 50 characters'),
    genderId: yup.number().required('Gender is required').typeError('Gender is required'),
    raceId: yup.number().required('Race is required').typeError('Race is required'),
    nationalityId: yup.number().nullable().transform((curr, orig) => (orig === '' ? 0 : curr)),
    disabled: yup.bool().nullable(),
    dateOfBirth: yup.date().nullable().default(null).transform((curr, orig) => orig === '' ? null : curr)
}, [['employeeCode', 'idNumber']]);



